import { createAnatomy as g } from "../../anatomy/dist/index.mjs";
import { createScope as l, query as o, queryAll as n } from "../../dom-query/dist/index.mjs";
import { createProps as a } from "../../types/dist/index.mjs";
var s = g("date-picker").parts(
  "root",
  "label",
  "clearTrigger",
  "content",
  "control",
  "input",
  "monthSelect",
  "nextTrigger",
  "positioner",
  "prevTrigger",
  "rangeText",
  "table",
  "tableBody",
  "tableCell",
  "tableCellTrigger",
  "tableHead",
  "tableHeader",
  "tableRow",
  "trigger",
  "viewTrigger",
  "viewControl",
  "yearSelect",
  "presetTrigger"
);
s.build();
var d = l({
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `datepicker:${e.id}:label`;
  },
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `datepicker:${e.id}`;
  },
  getTableId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.table) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:table:${t}`;
  },
  getTableHeaderId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.tableHeader) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:thead`;
  },
  getTableBodyId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.tableBody) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:tbody`;
  },
  getTableRowId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.tableRow) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:tr:${t}`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `datepicker:${e.id}:content`;
  },
  getCellTriggerId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.cellTrigger) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:cell-trigger:${t}`;
  },
  getPrevTriggerId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.prevTrigger) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:prev:${t}`;
  },
  getNextTriggerId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.nextTrigger) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:next:${t}`;
  },
  getViewTriggerId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.viewTrigger) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:view:${t}`;
  },
  getClearTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.clearTrigger) ?? `datepicker:${e.id}:clear`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `datepicker:${e.id}:control`;
  },
  getInputId: (e, t) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.input) == null ? void 0 : i.call(r, t)) ?? `datepicker:${e.id}:input:${t}`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `datepicker:${e.id}:trigger`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `datepicker:${e.id}:positioner`;
  },
  getMonthSelectId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.monthSelect) ?? `datepicker:${e.id}:month-select`;
  },
  getYearSelectId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.yearSelect) ?? `datepicker:${e.id}:year-select`;
  },
  getFocusedCell: (e, t = e.view) => o(
    d.getContentEl(e),
    `[data-part=table-cell-trigger][data-view=${t}][data-focus]:not([data-outside-range])`
  ),
  getTriggerEl: (e) => d.getById(e, d.getTriggerId(e)),
  getContentEl: (e) => d.getById(e, d.getContentId(e)),
  getInputEls: (e) => n(d.getControlEl(e), "[data-part=input]"),
  getYearSelectEl: (e) => d.getById(e, d.getYearSelectId(e)),
  getMonthSelectEl: (e) => d.getById(e, d.getMonthSelectId(e)),
  getClearTriggerEl: (e) => d.getById(e, d.getClearTriggerId(e)),
  getPositionerEl: (e) => d.getById(e, d.getPositionerId(e)),
  getControlEl: (e) => d.getById(e, d.getControlId(e))
});
a()([
  "closeOnSelect",
  "dir",
  "disabled",
  "fixedWeeks",
  "focusedValue",
  "format",
  "getRootNode",
  "id",
  "ids",
  "isDateUnavailable",
  "isDateUnavailable",
  "locale",
  "max",
  "min",
  "modal",
  "name",
  "numOfMonths",
  "onFocusChange",
  "onOpenChange",
  "onValueChange",
  "onViewChange",
  "open",
  "open.controlled",
  "positioning",
  "readOnly",
  "selectionMode",
  "startOfWeek",
  "timeZone",
  "translations",
  "value",
  "view"
]);
a()(["index"]);
a()(["value"]);
a()(["columns", "id", "view"]);
a()(["disabled", "value", "columns"]);
a()(["view"]);
export {
  s as anatomy
};
